<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Liste stock</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Reference</th>
          <th class="px-6 pt-6 pb-4">Bin</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Cost</th>
          <th class="px-6 pt-6 pb-4">Category</th>
          <th class="px-6 pt-6 pb-4">Type</th>
          <th class="px-6 pt-6 pb-4">Quantity</th>
          <th class="px-6 pt-6 pb-4">Creation date</th>
        </tr>
        <tr v-for="stock in stocks.data" :key="stock.id" @click="showReturnForm(stock.id,stock.totalQuantity)" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer focus:text-indigo-500">
              {{ stock.reference }}
              <icon v-if="stock.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer focus:text-indigo-500">
              {{ stock.bin }}
              <icon v-if="stock.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.model.name }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.brand ? stock.brand.name : "" }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.cost }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.category.name }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.type }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.totalQuantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ stock.created_at }}
            </span>
          </td>
        </tr>
        <tr v-if="stocks.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No stock found.</td>
        </tr>
      </table>
      <!-- Return stock to siege -->
      <jet-dialog-modal :show="returnForm" :closeable="false" @close="returnForm = false">
        <template #title>
          Retourner le stock au siege
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <div class="px-3 pb-8 w-full lg:w-1/2">
                <label class="form-label">Quantité:</label>
                <jet-input type="number" min="1" :max="maxQuantity" class="w-24" v-model="quantity" placeholder="1" :error="errors.quantity"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="returnForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green" :class="{ 'opacity-25': sending }"
                      :disabled="sending" @click.native="returnSelection">
            Retourner
          </jet-button>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination :links="stocks.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetInput from '@/Jetstream/Input'

export default {
  metaInfo: {title: 'Stock'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetButton,
    JetSecondaryButton,
    JetInput
  },
  props: {
    errors: Object,
    stocks: Object,
    filters: Object,
  },
  data() {
    return {
      selected: null,
      quantity: null,
      maxQuantity: null,
      selectAll: false,
      returnForm: false,
      sending: false,
      processing: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('stock.listStock', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    showReturnForm(id, qty) {
      this.selected = id
      this.returnForm = true
      this.maxQuantity = qty
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    select() {
      this.selected = [];
      if (this.selectAll) {
        for (let i in this.stocks.data) {
          if (this.stocks.data.hasOwnProperty(i)) {
            this.selected.push(this.stocks.data[i].id);
          }
        }
      }
    },
    returnSelection() {
      const data = new FormData()
      data.append('id', this.selected || null)
      data.append('quantity', this.quantity || null)
      this.$inertia.post(this.route('stock.return'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.returnForm = false
          this.selected = [];
        },
        onSuccess: () => {
         this.returnForm = false
        },
      })
    }
  },
}
</script>
